var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from "@angular/common/http";
import { ActiveProfileService, IpsBaseWebService } from "imagine-ui-ng-core";
import { environment } from "../../../environments/environment";
var ShipmentService = /** @class */ (function (_super) {
    __extends(ShipmentService, _super);
    function ShipmentService(http, activeProfileService) {
        var _this = _super.call(this, http, environment, activeProfileService) || this;
        _this.activeProfileService = activeProfileService;
        _this.init("Shipment", "Shop", "v1");
        return _this;
    }
    ShipmentService.prototype.shipmentStatusList = function () {
        var route = this.urlApiBasePlusController + "Status";
        return this.getByRoute(route);
    };
    return ShipmentService;
}(IpsBaseWebService));
export { ShipmentService };
